import { combineReducers } from 'redux';
import embeddedCategories from './reducers/embeddedCategories';

const reducers = combineReducers({
    embeddedCategories,
});

export default reducers;
